module.exports = __webpack_public_path__ + "static/other/character_focused.be43aa74.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/fitFiveGame/character_focused.json
// module id = 2373
// module chunks = 0